<template>
    <div>
        <breadcrumb :routerList="[{to:'/rebate',title:'返利列表'},{title:'返利详情'}]"/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-pieceIn2">
                    <div class="h-pieceTitle2 h-mrb0">
                        <h1>基础信息</h1>
                    </div>
                    <div class="h-pieceInCon3 h-mrt30" style="background-color: white;border: none;">
                        <div class="h-formLine h-mrb-38">
                            <el-form :model="f"  ref="formLabelAlign" :inline="true"  class="demo-ruleForm h-formbLine">
                                <el-form-item label="客户名称"  class="h-elformWrap-2">
                                    <el-input v-model="f.custname" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="所属区域"  class="h-elformWrap-2">
                                    <el-input v-model="f.areaCode" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="返利金额"  class="h-elformWrap-2">
                                    <el-input v-model="f.cashable" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="剩余返利"  class="h-elformWrap-2">
                                    <el-input v-model="f.tocash" readonly></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-piece h-mrt30">
                <div class="h-pieceIn2">
                    <div class="h-pieceTitle2">
                        <h1>客户返利明细信息</h1>
                    </div>
                    <div class="h-pieceCon2">
                        <div class="h-formBox">
                            <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                                <el-form-item label="凭证日期">
                                    <el-col :span="11">
                                        <el-date-picker type="date"  value-format="yyyy-MM-dd" v-model="q.startdate" placeholder="选择时间"  style="width: 100%;"></el-date-picker>
                                    </el-col>
                                    <el-col class="line h-txtCenter" :span="2">至</el-col>
                                    <el-col :span="11">
                                        <el-date-picker type="date" value-format="yyyy-MM-dd" v-model="q.enddate" placeholder="选择时间" style="width: 100%;"></el-date-picker>
                                    </el-col>
                                </el-form-item>
                                <el-form-item class="h-formBtnOut">
                                    <el-button class="h-btn h-formBtn" @click="detail">检索</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div class="h-table h-mrt30">
                            <el-table
                                    ref="multipleTable"
                                    :data="tableData"
                                    stripe
									border
                                    style="width: 100%"
                            >
                                <el-table-column
                                        type="selection"
                                        width="55"
                                        label="全选"
                                >
                                </el-table-column>
                                <el-table-column
                                        fixed
                                        type="index"
                                        label="#"
                                        width="40">
                                </el-table-column>
                                <el-table-column
                                        prop="creditcode"
                                        label="贷项凭证"
                                        width="200">
                                </el-table-column>
                                <el-table-column
                                        prop="paperinvoice"
                                        label="纸质发票号"
                                        width="250">
                                </el-table-column>
                                <el-table-column
                                        prop="sysinvoice"
                                        label="系统发票号"
                                        width="200">
                                </el-table-column>
                                <el-table-column
                                        prop="vouchercode"
                                        label="凭证号"
                                        width="230">
                                </el-table-column>
                                <el-table-column
                                        prop="voucherdate"
                                        label="凭证日期"
                                >
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.voucherdate?scope.row.voucherdate.substr(0,10):'' }}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="h-tableB h-mrt30">
                               <!-- <div class="h-tableBL">
                                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import">批量导出</el-button>
                                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export" @click="daoru">批量导入</el-button>
                                </div>-->
                                <div class="h-pagination2">
                                    <pagination :page="q" @query="query"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="backL">返回</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from '../../../api/SystemService'
    export default {
        data() {
            return {
                dialogFormVisible2:false,
                tableData:[],
                //表单
                q:{
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                f:{
                },
                sid:'',
                //表格
                multipleSelection: [],
            }
        },
        created(){
            this.detail();
            this.query();
        },
        methods: {
            // 批量导入弹窗
            daoru() {
                this.dialogFormVisible2 = true;
            },
            detail(){
                this.q.sid = this.$route.query.sid;
                ss.Custcash.detail(this.q).then(rd => {
                    this.tableData = rd.records;
                    this.q.total = rd.total;
                })
            },
            query(){
                this.sid = this.$route.query.sid;
                ss.Custcash.selectBySid(this.sid).then(rd => {
                    this.f = rd;
                })
            },
            //表格
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            backL() {
                this.$router.push({
                    path: "/rebate"
                });
            }
        }
    }
</script>

<style>
.h-dialog3.dialogFormVisible3 .el-dialog__body {
        padding: 0 0.5rem 0.3rem 0.5rem;
    }
    .h-dialog3.dialogFormVisible3 .el-dialog__body .el-upload--picture-card {
        width: 100%;
        height: 103px;
        border: 1px dashed #7c9ec0;
        background: 0;
        line-height: 103px;
        margin-top: 20px;
        color: #4b4b4b;
        font-size: 18px;
    }
    .piliang1 {
        font-size: 18px;
        color: #303030;
        margin-top: 10px;
        margin-left: 10px;
    }
    .piliang2 {
        font-size: 16px;
        color: #919191;
        margin-top: 10px;
        margin-left: 10px;
    }
    .piliangBox {
        display: flex;
        margin-top: 20px;
        align-items: center;
        
        margin-bottom: 20px;
    }
    .piliangBox .imgs {
        font-size: 16px;
        color: #4b4b4b;
        margin-left: 10px;
        
    }
</style>
